import { _, type DataOptionItem, dateUtil, type PageContext } from '@zto/zpage'

import {
  ActivityBizType,
  ActivityCycleType,
  ActivityEffectiveType,
  ActivityJumpType,
  ActivityPlace,
  YesNo,
  YesNoStr
} from '@/config'

import { checkIsLongTermDate, getCommonOptionItem, getNumberRangeDataOptions } from '@/utils'

export enum AcivityDialogType {
  ADD = 0,
  EDIT = 1,
  VIEW = 2
}

const formItemStyleAttrs = Object.freeze({ style: 'width: 400px;' })

/**
 * 新增编辑对话框
 * @returns
 */
export function addEditDialog(dialogType: AcivityDialogType = AcivityDialogType.ADD) {
  const isEdit = dialogType === AcivityDialogType.EDIT
  const isView = dialogType === AcivityDialogType.VIEW
  const isAdd = dialogType === AcivityDialogType.ADD

  return ({ app }: PageContext) => {
    return {
      width: 700,
      labelWidth: 100,
      itemSpan: 24,

      formAttrs: {
        disabled: isView
      },

      onShow: async ({ data }: PageContext) => {
        let payload = { ...data }

        if (isEdit || isView) {
          const res = await app.request({
            api: 'admin/resource/queryInfo',
            params: { activityCode: data.activityCode }
          })

          payload = { ...payload, ...res }
        }
        if (payload.activityPlace === ActivityPlace.AKC_BRAND_LIST) {
          const newSp = payload.activityItemList.slice(0)
          payload.activityItemList = [{}]
          payload.activityItemList[0].spuGoodsList = newSp.map((item: any, index: number) => {
            if (item.headImage) {
              item.url = item.headImage
            }
            return item
          })
          if (newSp && newSp.length > 0) {
            payload.tileName = newSp[0].tileName
          }
        }

        if (payload.activityPlace === ActivityPlace.BANNER_TOP) {
          const activityItemList = payload.activityItemList || []
          if (activityItemList.length > 0) {
            payload.carouselDuration = activityItemList[0].carouselDuration
          }
        }
        if (checkIsLongTermDate(payload.endDate)) {
          payload.endDate = undefined
        }

        payload._oldData = _.deepClone(payload)

        // 是否禁用第一个banner
        payload._isDisabledBanner1 = true

        payload._activityPlaceOptions = app.getCommonOptions('activityPlace') || []
        try {
          // 获取活动位配置
          // const isDisabledBanner1Cfg = await requestSystemConfig(
          //   app,
          //   'tuxi.dms.cms.activity',
          //   'dms.cms.activity.disableBanner1'
          // )
          //
          // // 获取状态位配置
          // payload._isDisabledBanner1 = tryParseJson(isDisabledBanner1Cfg?.value, true)
          // if (payload._isDisabledBanner1) {
          //   payload._activityPlaceOptions = payload._activityPlaceOptions.filter(
          //     (it: any) => it.value !== ActivityPlace.BANNER_TOP
          //   )
          // }
        } catch (ex) {}

        // 解析映射活动信息
        if (payload.activityItemList) {
          payload.activityItemList.forEach((it: any) => {
            if (it.bizType === ActivityBizType.ACTIVITY) {
              const bizInfos = it.bizInfos || []

              it._bizNos = bizInfos.map((_it: any) => _it.bizNo)
              it._bizNames = bizInfos.map((_it: any) => _it.bizName)
            }
          })
        }

        return { payload }
      },

      beforeSubmit: async ({ data }: PageContext, model: any, options: any) => {
        const payload = _.deepClone(model.value)
        if (!payload.startDate) {
          app.ui.showMessage({ type: 'warning', message: '请检查开始时间' })
          return false
        }
        if (!payload.endDate) {
          app.ui.showMessage({ type: 'warning', message: '请检查结束时间' })
          return false
        }

        const now = new Date()
        const startMinDate = now.getTime() + 10 * 60 * 1000 // 当前时间 + 10 分钟
        const startMaxDate = now.getTime() + 30 * 24 * 60 * 60 * 1000 // 当前时间 + 30 天

        const startInputDate = new Date(payload.startDate).getTime()
        const endInputDate = new Date(payload.endDate).getTime()

        const endMinDate = startInputDate + 60 * 60 * 1000 // 开始时间 + 60 分钟
        const endMaxDate = startInputDate + 90 * 24 * 60 * 60 * 1000 // 开始时间 + 90 天

        // 新增资源位 或者 编辑为开始状态的资源位 开始时间要限制
        if (
          (isAdd || (isEdit && payload.activityStatus === 0)) &&
          (startInputDate < startMinDate || startInputDate > startMaxDate)
        ) {
          app.ui.showMessage({ type: 'warning', message: '开始时间的最小时间为T+10分钟，最大时间为T+30天' })
          return false
        }
        if (endInputDate < endMinDate || endInputDate > endMaxDate) {
          app.ui.showMessage({ type: 'warning', message: '结束时间的开始时间为T+60分钟，开始时间为T+90天' })
          return false
        }

        if (
          payload.activityItemList?.length &&
          payload.activityItemList[0].spuGoodsList &&
          payload.activityPlace === ActivityPlace.AKC_BRAND_LIST
        ) {
          const spuGoodsList = payload.activityItemList[0].spuGoodsList
          if (spuGoodsList.length < 5 || spuGoodsList.length > 10) {
            app.ui.showMessage({ type: 'warning', message: '瓷片商品最少得添加5个,最多添加10个' })
            return false
          }
          for (let i = 0; i < spuGoodsList.length; i++) {
            const spuGood = spuGoodsList[i]
            if (!spuGood.headImage) {
              app.ui.showMessage({ type: 'warning', message: '请上传商品' + (i + 1) + '头像' })
              return false
            }
            if (!spuGood.spuCode || !spuGood.spuName) {
              app.ui.showMessage({ type: 'warning', message: '请选择商品' + (i + 1) })
              return false
            }
          }
        }
        // 瓷片名称
        const tileName = payload.tileName || ''
        // debugger
        // 轮播时长
        const carouselDuration = payload.carouselDuration

        const activityPlaceItem = getCommonOptionItem('activityPlace', data.activityPlace)
        if (payload.activityItemList?.length) {
          if (activityPlaceItem.bizType === ActivityBizType.GOODS && payload.activityItemList[0].spuGoodsList) {
            payload.activityItemList = (payload.activityItemList[0].spuGoodsList || []).map((item: any) => {
              item.tileName = tileName
              return item
            })
          }
          payload.activityItemList.forEach((it: any) => {
            it.carouselDuration = carouselDuration
            // 重设所有区域信息
            if (it.effectiveType === ActivityEffectiveType.ALL) {
              it.areaList = null
            }

            // 移除业务编号相关类型
            if (!activityPlaceItem.bizType) {
              it.bizType = null
            }

            // 跳转类型可见但不为商品详情则清空bizType
            if (activityPlaceItem.jumpType) {
              if (it.jumpType !== ActivityJumpType.GOODS_DETAIL) {
                it.bizType = null
              }
            }

            // 如果bizType不为商品则删除goodsType
            if (it.bizType === ActivityBizType.ACTIVITY) {
              const _bizNos = it._bizNos || []
              const _bizNames = it._bizNames || []
              it.bizInfos = _bizNos.map((it: any, index: number) => ({ bizNo: it, bizName: _bizNames[index] }))

              // 删除中间字段
              delete it._bizNos
              delete it._bizNames

              it.bizNo = null
              it.bizName = null
            } else if (!it.bizType) {
              it.bizNo = null
              it.bizName = null
            }

            // bizType不为商品，则清空goodsType
            if (it.bizType !== ActivityBizType.GOODS) {
              it.goodsType = null
            }
          })
        }

        // 移除活动优先级相关信息
        if (!activityPlaceItem.activitySort) {
          payload.sort = null
          payload.activitySortList = null
        }
        payload.startDate = payload.startDate ? dateUtil.parseAndFormat(payload.startDate) : null
        payload.endDate = payload.endDate ? dateUtil.parseAndFormat(payload.endDate) : null
        delete payload._oldData
        delete payload._sortData
        delete payload._isDisabledBanner1
        delete payload._activityPlaceOptions
        delete payload.tileName

        return payload
      },

      formItems: [
        {
          label: '活动名称',
          type: 'input',
          prop: 'activityName',
          required: true,
          maxlength: 20,
          width: 400,
          itemAttrs: { style: 'width: 400px;' },
          dynamicAttrs: ({ data }: PageContext) => {
            return {
              options: data._activityPlaceOptions || [],
              disabled: isView || (isEdit && data.activityStatus === 1)
            }
          }
        },
        {
          label: '资源位',
          type: 'select',
          prop: 'activityPlace',
          required: true,
          itemAttrs: formItemStyleAttrs,
          dynamicAttrs: ({ data }: PageContext) => {
            return {
              options: data._activityPlaceOptions || [],
              disabled: isView || (isEdit && data.activityStatus === 1)
            }
          },
          onChange: async (model: any) => {
            model['activityItemList'] = []
          }
        },
        {
          type: 'activity-place',
          autoHeight: true,
          disabled: true,
          dynamicAttrs: ({ data }: PageContext) => {
            return { disabledBanner1: !!data._isDisabledBanner1 }
          }
        },
        {
          label: '轮播时长',
          type: 'select',
          prop: 'carouselDuration',
          options: 'activityTimeSort',
          maxlength: 6,
          default: 3,
          listAttrs: { readonly: isView },
          itemAttrs: formItemStyleAttrs,
          disabled: isView,
          // disabled: isView || (isEdit && activityStatus === 1),
          dynamicAttrs: ({ data }: PageContext) => {
            const hidden = data.activityPlace !== ActivityPlace.BANNER_TOP
            return { hidden, required: !hidden }
          }
          // _retrieveAttrs: () => {
          //   const hidden = data.activityPlace !== ActivityPlace.BANNER_TOP
          //   return { hidden, required: !hidden }
          // }
        },
        {
          label: '瓷片名称',
          type: 'input',
          prop: 'tileName',
          trim: true,
          maxlength: 12,
          itemAttrs: formItemStyleAttrs,
          dynamicAttrs: ({ data }: PageContext) => {
            console.log('===data:', data.activityPlace)
            const visible = data.activityPlace === '5'
            return {
              disabled: isView || (isEdit && data.activityStatus === 1),
              visible: visible,
              required: visible
            }
          }
        },
        {
          labelWidth: 0,
          prop: 'activityItemList',
          type: 'combo',
          autoAppendFirst: true,
          itemsAttrs: { span: 24 },
          span: 24,
          disabled: isView,
          autoHeight: true,
          itemAttrs: { style: 'padding-right: 30px;' },
          dynamicAttrs: (ctx: PageContext, options: any) => {
            const activityPlace = ctx.data.activityPlace || null
            const activityItemList = ctx.data.activityItemList || []

            const deleteDisabled = activityItemList.length === 1
            const addDisabled = activityItemList.length >= 5

            let items: any = []
            let noOperation = false
            let labelWidth: any = 0

            let comboAttrs: any = {}

            if (!activityPlace) {
              noOperation = true
              comboAttrs = { labelWidth: 0 }
              items = [{ type: 'html', html: '<div class="text-center">请先选择活动位</div>' }]
            } else if (activityPlace === ActivityPlace.BANNER_TOP) {
              comboAttrs = {
                labelWidth: 120,
                border: true,
                header: {
                  content: ({ data }: PageContext) => {
                    return { html: `<b class="text-title">活动${data.$index + 1}</b>` }
                  }
                },
                footer: { style: { paddingLeft: '120px' } }
              }

              items = activityPlaceItems(ctx, dialogType)
            } else {
              noOperation = true
              comboAttrs = { labelWidth: 90, border: false }
              items = activityPlaceItems(ctx, dialogType)
            }

            return { labelWidth, deleteDisabled, addDisabled, noOperation, items, comboAttrs }
          }
        },
        ...activityCycleType(dialogType)
        // {
        //   label: '活动优先级',
        //   type: 'activity-sort',
        //   prop: '_sortData',
        //   autoHeight: true,
        //   disabled: isView,
        //   dynamicAttrs: ({ data }: PageContext) => {
        //     const activityPlaceItem = getCommonOptionItem('activityPlace', data.activityPlace)
        //     const visible = activityPlaceItem?.activitySort === true
        //     return { hidden: !visible }
        //   }
        // }
      ],

      innerDialogs: {
        preview: ({ data }: PageContext) => {
          return {
            title: '预览',
            width: 500,
            bodyStyle: { width: '460px', height: '550px' },
            actions: { close: { label: '关闭' } },
            cmpt: ({ data }: PageContext) => {
              return { type: 'CActivityPreviewer', activityData: data }
            }
          }
        }
      },

      actions: [
        {
          name: 'preview',
          label: '预览',
          trigger: ({ dialogExposed }: any) => {
            const { dataModel, showInnerDialog } = dialogExposed
            showInnerDialog('preview', dataModel.value)
          }
        },
        ...(isView ? [] : [{ name: 'submit' }]),
        { name: 'close' }
      ]
    }
  }
}

/** 获取位置项 */
function activityPlaceItems(ctx: PageContext, dialogType: AcivityDialogType) {
  const isEdit = dialogType === AcivityDialogType.EDIT
  const isView = dialogType === AcivityDialogType.VIEW

  const app = ctx.app
  const formModel = ctx.data

  const activityPlace = formModel.activityPlace
  const activityItemList = formModel.activityItemList || []

  const activityPlaceItem = getCommonOptionItem('activityPlace', activityPlace) as DataOptionItem
  const carouselSortOptions = (app.getCommonOptions('activityCarouselSort') || []) as DataOptionItem[]

  const activityStatus = formModel.activityStatus

  /** 设置itemList值 */
  const resetItemListPropValue = (prop: string, val: any = null) => {
    if (!activityItemList.length || !prop) return

    activityItemList.forEach((it: any) => {
      if (!it) return

      it[prop] = val
    })
  }

  const showEffectiveType = !!activityPlaceItem?.effectiveType

  if (!showEffectiveType) {
    resetItemListPropValue('effectiveType', ActivityEffectiveType.ALL)
  }

  return [
    {
      label: '轮播顺序',
      type: 'select',
      prop: 'sort',
      options: 'activityCarouselSort',
      itemAttrs: formItemStyleAttrs,
      disabled: isView,
      // disabled: isView || (isEdit && activityStatus === 1),
      comboDynamicAttrs: ({ data: { comboModel, model } }: PageContext) => {
        const existsSorts = comboModel.data.map((it: any) => it.sort)
        // 已经选过的顺序无法再选
        const sortOptions = carouselSortOptions.filter(it => !existsSorts.includes(it.value))
        return { options: sortOptions }
      },
      _retrieveAttrs: () => {
        const visible = !!activityPlaceItem.sort
        if (!visible) {
          resetItemListPropValue('sort')
        }
        return { hidden: !visible, required: visible }
      }
    },
    {
      label: '活动标题',
      type: 'input',
      prop: 'headTitle',
      disabled: isView || (isEdit && activityStatus === 1),
      maxlength: 6,
      listAttrs: { readonly: isView },
      itemAttrs: formItemStyleAttrs,
      _retrieveAttrs: () => {
        const hidden = !activityPlaceItem?.headTitle
        if (hidden) {
          resetItemListPropValue('headTitle')
        }
        return { hidden, required: !hidden }
      }
    },
    {
      label: '标题图片',
      type: 'upload',
      prop: 'headImage',
      listAttrs: { readonly: isView },
      srcType: 'url',
      listType: 'image',
      accept: 'image/*',
      multiple: false,
      autoHeight: true,
      required: true,
      _retrieveAttrs: () => {
        const headImage = activityPlaceItem.headImage
        if (!headImage) {
          resetItemListPropValue('headImage')
          return { hidden: true, required: false }
        }

        const attrs = {
          label: headImage.label || '标题图片'
          // aspectLimit: headImage.aspectLimit,
          // aspectLimitAccuracy: 10
        }
        const uploadAttrs = {
          dialogTitle: '照片上传',
          storeGroup: 'public',
          sizeLimit: 100,
          tip: headImage.aspectLimit
            ? `建议图片宽度${headImage.aspectLimit[0]}像素，高度${headImage.aspectLimit[1]}像素`
            : '图片文件'
        }
        return { ...attrs, uploadAttrs }
      }
    },
    {
      label: '页面顶图',
      type: 'upload',
      prop: 'pageHeadImage',
      listAttrs: { readonly: isView },
      srcType: 'url',
      listType: 'image',
      accept: 'image/*',
      multiple: false,
      autoHeight: true,
      required: true,
      disabled: isView || (isEdit && activityStatus === 1),
      _retrieveAttrs: () => {
        const pageHeadImage = activityPlaceItem.pageHeadImage
        if (!pageHeadImage) {
          resetItemListPropValue('pageHeadImage')
          return { hidden: true, required: false }
        }
        const attrs = {
          aspectLimit: pageHeadImage.aspectLimit,
          aspectLimitAccuracy: 10
        }
        const uploadAttrs = {
          dialogTitle: '照片上传',
          storeGroup: 'public',
          sizeLimit: 100,
          tip: attrs.aspectLimit
            ? `限制图片宽度${attrs.aspectLimit[0]}像素，高度${attrs.aspectLimit[1]}像素`
            : '图片文件'
        }
        return { ...attrs, uploadAttrs }
      }
    },
    {
      label: '背景色',
      type: 'input',
      prop: 'bgColor',
      maxlength: 50,
      trim: true,
      disabled: isView || (isEdit && activityStatus === 1),
      itemAttrs: formItemStyleAttrs,
      _retrieveAttrs: () => {
        const visible = activityPlaceItem?.bgColor
        if (!visible) {
          resetItemListPropValue('bgColor')
        }
        return { hidden: !visible }
      }
    },
    {
      label: '宣传图',
      type: 'upload',
      prop: 'displayImage',
      listAttrs: { readonly: isView },
      srcType: 'url',
      listType: 'image',
      accept: 'image/*',
      multiple: false,
      autoHeight: true,
      required: true,
      disabled: isView || (isEdit && activityStatus === 1),
      _retrieveAttrs: () => {
        const displayImage = activityPlaceItem.displayImage
        if (!displayImage) {
          resetItemListPropValue('displayImage')
          return { hidden: true, required: false }
        }
        const attrs = {
          // aspectLimit: displayImage.aspectLimit,
          // aspectLimitAccuracy: 10
        }
        const uploadAttrs = {
          dialogTitle: '照片上传',
          storeGroup: 'public',
          sizeLimit: 100,
          tip: displayImage.aspectLimit
            ? `限制图片宽度${displayImage.aspectLimit[0]}像素，高度${displayImage.aspectLimit[1]}像素`
            : '图片文件'
        }
        return { ...attrs, uploadAttrs }
      }
    },
    {
      label: '宣传文案',
      type: 'input',
      prop: 'displayContent',
      trim: true,
      disabled: isView || (isEdit && activityStatus === 1),
      itemAttrs: formItemStyleAttrs,
      _retrieveAttrs: () => {
        const visible = activityPlaceItem?.displayContent
        if (!visible) {
          resetItemListPropValue('displayContent')
        }
        return { hidden: !visible, required: visible }
      }
    },
    {
      label: '跳转方式',
      type: 'checkbox',
      prop: 'jumpType',
      checkType: 'radio',
      disabled: isView || (isEdit && activityStatus === 1),
      options: 'activityJumpType',
      itemAttrs: formItemStyleAttrs,
      _retrieveAttrs: () => {
        const visible = activityPlaceItem?.jumpType

        if (!visible) {
          resetItemListPropValue('jumpType')
        }

        return { hidden: !visible, required: visible }
      }
    },
    {
      label: '选择商品',
      prop: 'spuGoodsList',
      type: 'product-selector',
      labelProp: 'spuGoodsList',
      _retrieveAttrs: () => {
        const visible = activityPlaceItem?.bizType === ActivityBizType.GOODS
        return { hidden: !visible, required: visible }
      }
    },
    {
      label: 'AppId',
      type: 'input',
      prop: 'jumpAppId',
      maxlength: 500,
      trim: true,
      itemAttrs: formItemStyleAttrs,
      comboDynamicAttrs: ({ data: { model } }: PageContext) => {
        const visible = activityPlaceItem?.jumpUrl || model?.jumpType === ActivityJumpType.OTHER
        if (!visible) model.jumpAppId = null

        return { hidden: !visible }
      }
      // dynamicAttrs: ({ data }: PageContext) => {
      //   const canEdit = (activityStatus === 1 && isEdit) || (activityStatus === 0 && isEdit)
      //   return { disabled: !canEdit }
      // }
    },
    {
      label: '跳转路由',
      type: 'input',
      prop: 'jumpUrl',
      maxlength: 500,
      required: true,
      trim: true,
      itemAttrs: formItemStyleAttrs,
      comboDynamicAttrs: ({ data: { model } }: PageContext) => {
        const visible = activityPlaceItem?.jumpUrl || model?.jumpType === ActivityJumpType.OTHER
        if (!visible) model.jumpUrl = null
        return { hidden: !visible, required: visible }
      }
    },
    {
      label: '显示倒计时',
      type: 'checkbox',
      prop: 'countdownEnabled',
      checkType: 'radio',
      disabled: isView || (isEdit && activityStatus === 1),
      options: [
        { label: '不显示', value: YesNo.NO },
        { label: '根据有效时间倒计时', value: YesNo.YES }
      ],
      _retrieveAttrs: () => {
        const hidden = !activityPlaceItem?.countdown
        if (hidden) {
          resetItemListPropValue('countdownEnabled')
        }
        return { hidden, required: !hidden }
      }
    },
    {
      label: '映射活动',
      type: 'fuzzy-select',
      prop: '_bizNos',
      labelProp: '_bizNames',
      api: 'tuxi.txsh.cms.pc.getEffectiveMarketingRules',
      tip: { html: '<div class="text-red">映射大促活动，映射后将在此资源位显示活动商品</div>' },
      triggerFocus: true,
      multiple: true,
      optionValueProp: 'ruleCode',
      optionLabelProp: 'marketingName',
      disabled: isView || (isEdit && activityStatus === 1),
      tpl: ({ data }: PageContext) => {
        return (
          `<div style="padding-bottom: 10px;">` +
          `  <div style="line-height: 20px;">${data.marketingName}</div>` +
          `  <div class="text-tip">` +
          `    <span class="q-mr-md">开始时间：${data.startDate || '--'}; </span>` +
          `    <span class="q-mr-md">状态：${data.statusName || '--'}</span>` +
          `  </div>` +
          `  <div class="text-tip">` +
          `    <span class="q-mr-md">结束时间：${data.endDate || '--'}; </span>` +
          `  </div>` +
          `</div>`
        )
      },
      itemAttrs: formItemStyleAttrs,
      _retrieveAttrs: () => {
        const visible = activityPlaceItem?.bizType === ActivityBizType.ACTIVITY
        if (visible) {
          resetItemListPropValue('bizType', ActivityBizType.ACTIVITY)
        }
        return { hidden: !visible, required: visible }
      }
    }
  ]
    .map(it => {
      const exAttrs = it._retrieveAttrs ? it._retrieveAttrs() : {}
      return { ...it, ...exAttrs, _activityItemList: true }
    })
    .filter((it: any) => it?.hidden !== true)
}

/** 活动循环周期 */
function activityCycleType(dialogType: AcivityDialogType) {
  const isEdit = dialogType === AcivityDialogType.EDIT
  const isView = dialogType === AcivityDialogType.VIEW

  return [
    {
      label: '开始时间',
      type: 'date-picker',
      prop: 'startDate',
      pickerType: 'datetime',
      format: 'YYYY-MM-DD HH:mm',
      afterToday: true,
      disabled: isEdit,
      beforeDate: 'T+30d',
      afterDate: 'T+0d',
      itemAttrs: formItemStyleAttrs,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = true
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    },
    {
      label: '结束时间',
      type: 'date-picker',
      prop: 'endDate',
      pickerType: 'datetime',
      format: 'YYYY-MM-DD HH:mm',
      afterToday: true,
      beforeDate: 'T+90d',
      afterDate: 'T+0d',
      require: true,
      itemAttrs: formItemStyleAttrs,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = true
        return { hidden: !visible, required: visible, disabled: isView }
      }
    },
    {
      label: '活动时间类型',
      type: 'select',
      prop: 'monthLastExeFlag',
      options: [
        { label: '每月指定日期', value: YesNoStr.NO },
        { label: '每月最后一天', value: YesNoStr.YES }
      ],
      default: YesNoStr.NO,
      disabled: isEdit,
      itemAttrs: formItemStyleAttrs,
      onChange: (model: any) => {
        model.cycleDay = []
      },
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = data.cycleType == ActivityCycleType.MONTH
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    },
    {
      label: '每月生效日期',
      type: 'select',
      prop: 'cycleDay',
      options: getNumberRangeDataOptions(1, 30),
      multiple: true,
      collapseTags: false,
      autoHeight: true,
      disabled: isEdit,
      itemAttrs: formItemStyleAttrs,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = data.cycleType === ActivityCycleType.MONTH && data.monthLastExeFlag === YesNoStr.NO
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    },
    {
      label: '是否跳过2月',
      type: 'checkbox',
      prop: 'febIgnoreFlag',
      checkType: 'radio',
      options: [
        { label: '是, 2月不循环', value: YesNoStr.YES },
        { label: '否，2月指定日期', value: YesNoStr.NO }
      ],
      default: YesNoStr.NO,
      itemAttrs: formItemStyleAttrs,
      required: true,
      disabled: isEdit,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = data.cycleType == ActivityCycleType.MONTH
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    },
    {
      label: '2月生效日期',
      type: 'select',
      prop: 'febExeDay',
      multiple: true,
      collapseTags: false,
      autoHeight: true,
      options: getNumberRangeDataOptions(1, 29),
      disabled: isEdit,
      itemAttrs: formItemStyleAttrs,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = data.cycleType == ActivityCycleType.MONTH && data.febIgnoreFlag === YesNoStr.NO
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    },
    {
      label: '每周生效日期',
      labelWidth: 138,
      type: 'select',
      prop: 'cycleDay',
      options: 'weekdays',
      multiple: true,
      collapseTags: false,
      autoHeight: true,
      disabled: isEdit,
      itemAttrs: formItemStyleAttrs,
      dynamicAttrs: ({ data }: PageContext) => {
        const visible = data.cycleType == ActivityCycleType.WEEK
        return { hidden: !visible, required: visible, disabled: isView || (isEdit && data.activityStatus === 1) }
      }
    }
  ]
}
